import { executeStandardRequest, type MusinsaStandardResponse } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { mypageQueryKeys } from './queryKeys';
import type { MyPageResponse } from './types';

export type GetMypageResponse = MusinsaStandardResponse<MyPageResponse>;

export const getMypage = async () =>
  executeStandardRequest(() => privateHttpClient.get<GetMypageResponse>(mypageQueryKeys.getMypage));
